export enum ClientTypeEnum {
  Individual = "1",
  Company = "2",
  Foreigner = "3",
}
